module.exports = __webpack_public_path__ + "media/images/applicant/icon-ku-blue-ef5cc65823bb8d0123e4a78591d1a991.png";